import { render, staticRenderFns } from "./BillingHistory.vue?vue&type=template&id=4c05c680&scoped=true"
import script from "./BillingHistory.vue?vue&type=script&lang=js"
export * from "./BillingHistory.vue?vue&type=script&lang=js"
import style0 from "./BillingHistory.vue?vue&type=style&index=0&id=4c05c680&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05c680",
  null
  
)

export default component.exports